<template>
  <main v-if="location" class="location">
    <div class="content padded">
      <section>
        <div class="info">
          <h3 v-if="location.name">{{location.name}}</h3>
          <p class="brands" v-if="location.brands">
            {{location.brands}}
          </p>
          <p v-if="location.address">
            <span>{{location.address}}</span><br>
            <span>{{location.city}}, {{location.state}} {{location.zip}}</span><br>
            <a :href="'tel:'+location.tel">{{location.tel}}</a>
            <span>{{location.fax}} (fax)</span><br>
            <span><strong><a target="_blank" :href="location.directions">Get Directions</a></strong></span>
          </p>
        </div>
        <div class="map">
          <gmap-map :center="center" :zoom="12" style="width:100%;  height: 400px;">
            <gmap-marker
              :position="center"
              :title="location.name"
            ></gmap-marker>
          </gmap-map>
        </div>
        <div class="image">
          <img :src="location.image"/>
        </div>
      </section>
      <aside>
        <div class="sidebar-item" v-for="(item, index) in location.sidebar" >
          <div v-if="item.heading">
            <h3>{{ item.heading }}</h3>
            <div v-html="item.markup"></div>
          </div>
          <div v-else="">
            <div class="no-heading" v-html="item.markup"></div>
          </div>
        </div>
      </aside>
    </div>
  </main>
</template>

<script>
import axios from 'axios';
//import GoogleMap from './GoogleMap.vue';

var mapobj; // will be filled with object literal from API
if(mapobj){
  console.log(mapobj["lat"]);
}

export default {
  name:'Location',
  data() {
    return {
      loc: this.$route.params.loc,
      location: null,
      center: mapobj
    };
  },
  //If this component hasn't been rendered.
  beforeRouteEnter (to, from, next) {
    axios.get('https://www.advantagetruckne.com/api/?id='+to.params.loc)
      .then(response => {
        document.title = to.meta.title
        mapobj = response.data.map;
        next(vm => (vm.location = response.data));
      })
      $('html, body').animate({
        scrollTop: $('html, body')
      }, 1000);
  },
  //If this component is already rendered.
  beforeRouteUpdate (to, from, next) {
    document.title = to.meta.title
    axios
      .get('http://localhost:9000/api/?id='+to.params.loc)
      .then(response => (this.location = response.data))
    next();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Locations.vue